<template>
  <a-dropdown>
    <a-button>
      <span>树操作</span>
      <ant-icon type="DownOutlined"></ant-icon>
    </a-button>
    <template #overlay>
      <a-menu @click="onClick">
        <a-menu-item key="UNFOLD_ALL">展开全部</a-menu-item>
        <a-menu-item key="FOLD_ALL">收起全部</a-menu-item>
        <a-menu-item v-if="selectable" key="CHECK_ALL">全部勾选</a-menu-item>
        <a-menu-item v-if="selectable" key="UNCHECK_ALL">取消全选</a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  isGlobal: true,
  name: "TreeAction",
  props: {
    selectable: { type: Boolean, default: true },
  },
  emits: ["select"],
  setup(props, { emit }) {
    const onClick = ({ key }) => {
      emit("select", key);
    };

    return { onClick };
  },
});
</script>
